import * as angular from "angular";
import {IController} from 'angular';

export class bringozMultiselectItemCtrl implements IController {

  name: any;
  doTranslate: boolean;
  isSelected: any;
  isExcluded: boolean;
  tags?: string[];
  skills?: string[];
  showTags?: string[];
  onToggle: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  };

  toggle(event) {
    this.onToggle({isSelected: !this.isSelected});
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozMultiselectItem', {
    bindings: {
      name: '<',
      doTranslate: '<?',
      isSelected: '<?',
      isExcluded: '<?',
      tags: '<?', // When refactoring to Angular move to ng-content
      skills: '<?', // When refactoring to Angular move to ng-content
      showTags: '<?',
      onToggle: '&'
    },
    template: require('./bringoz-multiselect-item.html').default,
    controller: bringozMultiselectItemCtrl
  });
